<script>
    let { switch_state = $bindable(1) } = $props();
</script> 
<div class="field has-addons">
    <p class="control">
        <button class="button is-small" class:is-selected={switch_state==1} class:is-link={switch_state==1} onclick={(e)=>{e.preventDefault(); switch_state = 1;}}>Visited</button>
    </p>            
    <p class="control">
        <button class="button is-small" class:is-selected={switch_state==2} class:is-link={switch_state==2} onclick={(e)=>{e.preventDefault(); switch_state = 2;}}>All</button>
    </p>            
    <p class="control">
        <button class="button is-small" class:is-selected={switch_state==3} class:is-link={switch_state==3} onclick={(e)=>{e.preventDefault(); switch_state = 3;}}>Remaining</button>
    </p>            
</div>
